import standard_frontend_html from './standard/frontend/html'
import standard_frontend_react from './standard/frontend/react'
import standard_frontend_angular from './standard/frontend/angular'
import standard_backend_node from './standard/backend/nodejs'
import standard_backend_python from './standard/backend/python'
import standard_backend_php from './standard/backend/php'

import advanced_frontend_angular from './advanced/frontend/angular'
import advanced_frontend_html from './advanced/frontend/html'
import advanced_frontend_react from './advanced/frontend/react'

import advanced_backend_java from './advanced/backend/java'
import advanced_backend_nodejs from './advanced/backend/nodejs'
import advanced_backend_python from './advanced/backend/python'
import advanced_backend_php from './advanced/backend/php'

import { SnippetSchema } from '../interfaces/SnippetSchema'

export const checkoutSimulatorSnippets: SnippetSchema[] = [
  {
    name: 'standard',
    environments: [
      {
        name: 'frontend',
        samples: [
          {
            language: 'html',
            files: standard_frontend_html,
          },
          {
            language: 'react',
            files: standard_frontend_react,
          },
          {
            language: 'angular',
            files: standard_frontend_angular,
          },
        ],
      },
      {
        name: 'backend',
        samples: [
          {
            language: 'nodejs',
            files: standard_backend_node,
          },
          {
            language: 'python',
            files: standard_backend_python,
          },
          {
            language: 'php',
            files: standard_backend_php,
          },
        ],
      },
    ],
  },
  {
    name: 'advanced',
    environments: [
      {
        name: 'frontend',
        samples: [
          {
            language: 'html',
            files: advanced_frontend_html,
          },
          {
            language: 'react',
            files: advanced_frontend_react,
          },
          {
            language: 'angular',
            files: advanced_frontend_angular,
          },
        ],
      },
      {
        name: 'backend',
        samples: [
          // {
          //   language: 'java',
          //   files: advanced_backend_java,
          // },
          {
            language: 'nodejs',
            files: advanced_backend_nodejs,
          },
          {
            language: 'python',
            files: advanced_backend_python,
          },
          {
            language: 'php',
            files: advanced_backend_php,
          },
        ],
      },
    ],
  },
].map((snippet) => ({
  ...snippet,
  environments: snippet.environments.map((environment) => ({
    ...environment,
    samples: environment.samples.map((sample) => ({
      ...sample,
      files: sample.files.map((file: any) => ({
        ...file,
        integration: snippet.name,
        environment: environment.name,
        language: sample.language,
      })),
    })),
  })),
}))
